import React from 'react';
import { Pressable, View } from 'react-native';

import { cn } from '../../lib/utils';
import { useListItemPosition } from './ListContainer';

export type ListItemPropsType = {
  pressable?: boolean;
  onPress?: () => void;
  children: React.ReactNode;
  className?: string;
};

const borders = {
  top: 'rounded-tr-2xl rounded-tl-2xl',
  bottom: 'rounded-br-2xl rounded-bl-2xl',
  full: 'rounded-2xl',
};

export const ListItem = ({
  pressable = false,
  onPress,
  children,
  className,
}: ListItemPropsType) => {
  const position = useListItemPosition();
  const border = position !== 'middle' ? borders[position] : '';

  const styles = 'flex flex-row w-full items-center px-3 py-4 bg-neutral-600';
  const pressableStyles = 'group hover:bg-[#293165] active:bg-primary';

  return pressable ? (
    <Pressable
      onPress={onPress}
      className={cn(styles, pressableStyles, border, className)}>
      {children}
    </Pressable>
  ) : (
    <View className={cn(styles, border, className)}>{children}</View>
  );
};
